<template>
  <div class="dea-input-container dea-input-container--date">
    <label class="dea-input-container__label dea-input-container__label--date" for="startDate">{{ label }}</label>
    <datepicker
      id="startDate"
      input-class="dea-input dea-input--date"
      placeholder="Seleziona Data Inizio"
      :disabled-dates="disabledStartDates"
      :language="it"
      @selected="assignAndSearchStartDate"
    ></datepicker>
    <datepicker
      input-class="dea-input dea-input--date"
      placeholder="Seleziona Data Fine"
      :disabled-dates="disabledEndDates"
      :language="it"
      @selected="assignAndSearchEndDate"
    ></datepicker>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { it } from "vuejs-datepicker/dist/locale";

export default {
  name: "DateSelect",
  components: {
    Datepicker,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      it,
      endDate: null,
      startDate: null,
    };
  },
  computed: {
    /* eslint-disable */
    disabledStartDates() {
      if (this.endDate) {
        return {
          from: new Date(this.endDate),
        };
      }
    },
    disabledEndDates() {
      if (this.startDate) {
        return {
          to: new Date(this.startDate),
        };
      }
    },
    /* eslint-enable */
  },
  methods: {
    assignAndSearchStartDate(e) {
      this.startDate = `${e.getFullYear()}-${e.getMonth() + 1}-${e.getDate()}`;
      this.triggerSearch();
    },
    assignAndSearchEndDate(e) {
      this.endDate = `${e.getFullYear()}-${e.getMonth() + 1}-${e.getDate()}`;
      this.triggerSearch();
    },
    triggerSearch() {
      this.$emit("trigger-search", { startDate: this.startDate, endDate: this.endDate });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils.scss"; //sass-lint:disable-line clean-import-paths

.dea-input-container--date {
  margin-left: $space-small;
}

.dea-input-container__label--date {
  display: block;
  font-family: $font-primary-medium;
  font-size: $h-font-size-xx-small;
  margin: $space-x-small 0 $space-xx-small;
  text-transform: uppercase;

  & + .vdp-datepicker {
    margin-top: $space-small;
  }
}

.vdp-datepicker + .vdp-datepicker {
  margin-top: $space-x-small;
}

.dea-input--date {
  background-color: $dea-color-grey-light;
  border: 0;
  max-width: 100%;
  outline: none;
  padding: $space-small;
  width: 100%;

  &::placeholder {
    @include p_font-size-small; //sass-lint:disable-line mixin-name-format
    color: $dea-color-black;
    font-family: $font-primary-medium;
    font-weight: $font-weight-light;
    text-transform: capitalize;
  }
}
</style>
